import { render } from "./ManagerAdminView.vue?vue&type=template&id=8d2aa40e"
import script from "./ManagerAdminView.vue?vue&type=script&lang=js"
export * from "./ManagerAdminView.vue?vue&type=script&lang=js"

import "./ManagerAdminView.vue?vue&type=style&index=0&id=8d2aa40e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__